import React from "react";

/** Placeholder rows while a table loads. */
const TableSkeleton: React.FC<{ rows?: number; cols: number }> = ({ rows = 8, cols }) => (
  <>
    {Array.from({ length: rows }, (_, r) => (
      <tr key={r} aria-hidden="true">
        {Array.from({ length: cols }, (_, c) => (
          <td key={c} className="px-3 py-3">
            <div className="h-3.5 animate-pulse rounded bg-gray-700/70" style={{ width: `${50 + ((r + c) % 4) * 12}%` }} />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default TableSkeleton;
